import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Careers = () => {
    const roles = [
        { title: "Senior Neural Architect", dept: "Engineering", loc: "Remote / Hyper-V" },
        { title: "Quantum Algorithms Engineer", dept: "R&D", loc: "New York Node" },
        { title: "Frontend Holography Specialist", dept: "Design", loc: "San Francisco Node" },
        { title: "Cyber-Security Sentinel", dept: "Security", loc: "Remote / VPN" },
    ];

    return (
        <div className="min-h-screen bg-cyber-gray text-white font-rajdhani relative overflow-hidden">
            {/* Background Grid Animation */}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 relative z-10">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-center mb-16"
                >
                    <h1 className="text-5xl md:text-7xl font-bold font-orbitron bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 via-white to-red-500 mb-6">
                        JOIN THE COLLECTIVE
                    </h1>
                    <p className="text-xl text-gray-400">
                        Upload your consciousness to our team. We are looking for advanced units to scale our operations.
                    </p>
                </motion.div>

                <div className="grid gap-6">
                    {roles.map((role, index) => (
                        <motion.div
                            key={index}
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: index * 0.1 }}
                            whileHover={{ scale: 1.01, x: 10 }}
                            className="bg-gray-900 border border-gray-800 p-6 rounded-lg flex items-center justify-between cursor-pointer group hover:border-yellow-400 transition-colors"
                        >
                            <div>
                                <h3 className="text-2xl font-bold font-orbitron text-white group-hover:text-yellow-400 transition-colors">{role.title}</h3>
                                <div className="flex gap-4 mt-2 text-sm text-gray-500 font-mono uppercase">
                                    <span>{role.dept}</span>
                                    <span>|</span>
                                    <span>{role.loc}</span>
                                </div>
                            </div>
                            <ArrowRight className="w-6 h-6 text-gray-600 group-hover:text-yellow-400 group-hover:translate-x-2 transition-all" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Careers;
